import { Collapse, Grid, Menu, TableCell, TableRow, Typography } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { ReactNode } from 'react'
import { IOProps } from 'react-compose-io'
import { EditarItemTabela } from '../../../../components/EditarItemTabela/EditarItemTabela'
import IconeButton from '../../../../components/IconeButton/IconeButton'
import { PAGES } from '../../../../router/routes'
import { cabecalhoNotaFiscalRegras } from '../../../../types/tabelaTypes'
import { checarStatus, formateDate } from '../../../../utils/stringUtils'
import { ItemNotaFiscalIO } from './ItemNotaFiscal.IO'

export type ItemNotaFiscalProps = {
  linhaItemNotaFiscal: any
  index: number
  atualizarDados: () => void
}

export function ItemNotaFiscalView({ _io, linhaItemNotaFiscal }: IOProps<ItemNotaFiscalIO, ItemNotaFiscalProps>) {
  const { BoxHistorico, TableRowHistorico } = _io.styles

  const editouSequencia =
    linhaItemNotaFiscal?.dataEdicao != null ? (
      <Grid item xs={12}>
        <BoxHistorico>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Editou Sequência</Typography>
          </Grid>
          <Grid item xs={12}>
            {formateDate(linhaItemNotaFiscal?.dataEdicao, true)} - {linhaItemNotaFiscal?.usuarioEdicao ?? '-'}
          </Grid>
        </BoxHistorico>
      </Grid>
    ) : null

  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={_io.handleAbrirToogle}>
            {_io.abrir ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="center">{linhaItemNotaFiscal.nomeRegra || ' -- '}</TableCell>
        <TableCell align="center">{linhaItemNotaFiscal.campo || ' -- '}</TableCell>
        <TableCell align="center">{checarStatus(linhaItemNotaFiscal.ativo)}</TableCell>
        <TableCell align="center">
          <div>
            <IconeButton color="inherit" descricao="ações" icone={<MoreVertIcon />} acao={_io.handleAlterarIconeAncora} />
            <Menu id="simple-menu" anchorEl={_io.ancoraAtiva} keepMounted open={Boolean(_io.ancoraAtiva)} onClose={_io.handleAnularIconeAncora}>
              {EditarItemTabela(
                linhaItemNotaFiscal,
                _io.editarRegraNotaFiscal,
                _io.desativarRegraNotaFiscal,
                PAGES.transformacaoNotaFiscalEditar(_io.parceiroId, String(linhaItemNotaFiscal.regraId))
              ).map((itemMenu: ReactNode) => {
                return itemMenu
              })}
            </Menu>
          </div>
        </TableCell>
      </TableRow>
      <TableRowHistorico>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={cabecalhoNotaFiscalRegras.length}>
          <Collapse in={_io.abrir} timeout="auto" unmountOnExit>
            <BoxHistorico>
              <Typography variant="subtitle2" gutterBottom component="div">
                Histórico
              </Typography>
              {linhaItemNotaFiscal?.dataCadastro ? (
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <BoxHistorico>
                      <Grid item xs={12}>
                        <Typography variant="subtitle2">Cadastramento</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body2">
                          {formateDate(linhaItemNotaFiscal?.dataCadastro, true)} - {linhaItemNotaFiscal?.usuarioCadastro ?? '-'}
                        </Typography>
                      </Grid>
                    </BoxHistorico>
                  </Grid>
                  {editouSequencia}
                </Grid>
              ) : null}
            </BoxHistorico>
          </Collapse>
        </TableCell>
      </TableRowHistorico>
    </>
  )
}
